import { ImageViewer } from "@/lib/image-viewer";
import { ImagesViewer } from "@/lib/images-viewer";
import { createContext, useContext, useState } from "react";

type ImagePreviewContextType = {
    imagePreview: string | null;
    imagesPreview: string[] | null;
    setImagesPreview: (imagesPreview: string[] | null) => void;
    setImagePreview: (imagePreview: string | null) => void;
    setPreviewData: (previewData: any) => void;
    setPreviewType: (previewType: 'image' | 'iframe' | 'images') => void;
    openImagesPreview: (images: string[]) => void;
};

const ImagePreviewContext = createContext<ImagePreviewContextType | null>(null);

export const ImagePreviewProvider = ({ children }: any) => {
    const [imagesPreview, setImagesPreview] = useState<string[] | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [previewData, setPreviewData] = useState<string | null>(null);
    const [previewType, setPreviewType] = useState<'image' | 'iframe' | 'images'>('image');
    const openImagesPreview = (images: string[]) => {
        reset();
        setImagesPreview(images);
        setPreviewType('images');
    }
    const reset = () => {
        setImagesPreview(null);
        setImagePreview(null);
        setPreviewData(null);
        setPreviewType('image')
    }
    return <ImagePreviewContext.Provider value={{ imagesPreview, imagePreview, setImagesPreview, setImagePreview, setPreviewData, setPreviewType, openImagesPreview }}>
        {children}
        {previewType === 'images' ? <>
            <ImagesViewer
                isOpen={previewType === 'images' && !!imagesPreview?.length}
                onOpenChange={(open) => {
                    if (!open) {
                        setImagesPreview(null);
                        setPreviewType('image');
                    }
                }}
                images={imagesPreview}
            />
        </> : <>
            <ImageViewer
                isOpen={!!imagePreview || previewType === 'iframe'}
                onOpenChange={(open) => {
                    if (!open) {
                        setImagePreview(null);
                        setPreviewData(null);
                        setPreviewType('image');
                    }
                }}
                imageUrl={imagePreview}
                previewData={previewData}
                previewType={previewType}
                alt="Xem ảnh chi tiết"
            />
        </>}
    </ImagePreviewContext.Provider>
}
export const useImagePreview = () => {
    const context = useContext(ImagePreviewContext);
    if (!context) throw new Error("ImagePreviewContext must be init");
    return context;
}